import { Block } from './block'
import { createSvgElement, updateAttributesSvgElement } from '../svg'

export class InputBlock extends Block {
  constructor(name, flowchart) {
    super(flowchart)

    this.name = name
  }

  create() {
    super.create()

    var rect = createSvgElement('polygon')
    updateAttributesSvgElement(rect, {
      class: 'flowchart-block',
      points: `20,0 ${this.width},0 ${this.width - 20},${this.height} 0,${this.height}`
    })

    var text = createSvgElement('text')
    updateAttributesSvgElement(text, {
      class: 'flowchart-text'
    })
    text.textContent = 'Get ' + this.name

    this.flowchart.element.appendChild(this.element)

    this.element.appendChild(rect)
    this.element.appendChild(text)

    var boundingClientRect = text.getBoundingClientRect()

    updateAttributesSvgElement(text, {
      x: 110 - boundingClientRect.width / 2,
      y: boundingClientRect.height / 4 + 35
    })
  }

  beforeOnExecute() {
    this.hasValue = new Promise(resolve => {
      this.resolve = resolve
    })
    this.flowchart.listenInput(this, this.name)
  }

  onExecute() {
    return this.hasValue
  }

  set(value) {
    this.resolve()
    this.flowchart.setVariable(this.name, value)
  }
}
